module.exports = __webpack_public_path__ + "img/antes_despues_132.15f94d12.png";